import React from "react";
import { useTranslation } from "react-i18next";
import { purgeImpactRows } from "../../lib/purgeConfirm";

const Row = ({ label, value, testId }) => (
  <div className="qw-life-row">
    <span className="qw-life-label">{label}</span>
    <span data-testid={testId}>{value}</span>
  </div>
);

/**
 * The dry run: what a purge would destroy, as AGGREGATE counts only.
 *
 * Per affected table plus the two totals. The backend deliberately does not send
 * storage paths, file names, customer names, quotation titles or recipient
 * addresses, so there is nothing here to redact.
 */
export const PlatformPurgeImpact = ({ preview }) => {
  const { t } = useTranslation();
  const rows = purgeImpactRows(preview?.row_counts);

  return (
    <div data-testid="platform-purge-impact">
      <div style={{ fontWeight: 600, marginBottom: 8 }} data-testid="platform-purge-impact-title">
        {t("platform.purge_preview_title")}
      </div>
      {rows.length === 0 ? (
        <div className="qw-empty" data-testid="platform-purge-impact-empty">
          {t("platform.purge_impact_empty")}
        </div>
      ) : (
        <div className="qw-life-grid">
          {rows.map(({ table, count }) => (
            <Row
              key={table}
              label={t(`platform.purge_table_${table}`, { defaultValue: table })}
              value={String(count)}
              testId={`platform-purge-rows-${table}`}
            />
          ))}
        </div>
      )}
      <div className="qw-life-grid" style={{ marginTop: 10 }}>
        <Row
          label={t("platform.purge_rows_total")}
          value={String(preview?.rows_total ?? 0)}
          testId="platform-purge-rows-total"
        />
        <Row
          label={t("platform.purge_storage_total")}
          value={String(preview?.storage_objects_total ?? 0)}
          testId="platform-purge-files-total"
        />
      </div>
    </div>
  );
};

export default PlatformPurgeImpact;
